import { Link } from "gatsby"
import React from "react"
import { styled } from "styled-components"
import { breakpoints } from "../Theme"

const StyledTabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Inner = styled.div`
  display: inline-flex;
  border: 2px solid var(--color-purple);
  border-radius: 25px;
  box-sizing: border-box;
  overflow: hidden;
`

const StyledTab = styled(Link)`
  background-color: ${props =>
    props.$active ? `var(--color-purple)` : "transparent"};
  color: ${props =>
    props.$active ? `var(--color-white)` : "var(--color-purple)"};
  padding: var(--spacer-s) var(--spacer-m);
  text-decoration: ${props => (props.$active ? `none` : "underline")};
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  overflow: hidden;

  @media ${breakpoints.l} {
    padding: var(--spacer-s) var(--spacer-l);
    min-width: 200px;
  }
`

function Tabs({ children }) {
  return (
    <StyledTabs>
      <Inner>{children}</Inner>
    </StyledTabs>
  )
}

function Tab({ to = "/", active, children }) {
  return (
    <StyledTab to={to} $active={active}>
      {children}
    </StyledTab>
  )
}

Tabs.Tab = Tab

export default Tabs
